import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import './submission.css';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

function SubAdd() {
  const { id } = useParams();
  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  const [subID, setSubID] = useState(null);

  const [subGrader, setSubGrader] = useState('');
  const [subOrderNumber, setSubOrderNumber] = useState('');
  const [subDate, setSubDate] = useState('');
  const [subReturnDate, setSubReturnDate] = useState('');
  const [subPreCost, setSubPreCost] = useState('');
  const [subUpcharge, setSubUpcharge] = useState('');
  const [subTotalCards, setSubTotalCards] = useState('');
  const [subShippingTo, setSubShippingTo] = useState('');
  const [subShippingFrom, setSubShippingFrom] = useState('');
  const [subNotes, setSubNotes] = useState('');

  const [subPSAorderArrived, setSubPSAorderArrived] = useState('');
  const [subPSAorderPrep, setSubPSAorderPrep] = useState('');
  const [subPSAresearchID, setSubPSAresearchID] = useState('');
  const [subPSAgrading, setSubPSAgrading] = useState('');
  const [subPSAassembly, setSubPSAassembly] = useState('');
  const [subPSAgradesReady, setSubPSAgradesReady] = useState('');
  const [subPSAqaChecks, setSubPSAqaChecks] = useState('');
  const [subPSAcompleted, setSubPSAcompleted] = useState('');

  // 🔑 FIXED: no timezone shifting, just grab YYYY-MM-DD
  function convertISOToDateInputValue(isoString) {
    if (!isoString) return '';
    // Handles "YYYY-MM-DD" or "YYYY-MM-DDTHH:MM:SSZ"
    return isoString.split('T')[0];
  }

  useEffect(() => {
    axios
      .get(`https://api.alientrader.cards/submission/${id}`)
      .then((response) => {
        const row = response.data && response.data[0];
        if (!row) return;

        setSubID(row);

        setSubGrader(row.sub_grader || '');
        setSubOrderNumber(row.sub_order_number || '');
        setSubDate(row.sub_date ? convertISOToDateInputValue(row.sub_date) : '');
        setSubReturnDate(
          row.sub_return_date ? convertISOToDateInputValue(row.sub_return_date) : ''
        );
        setSubTotalCards(row.sub_total_cards || '');
        setSubPreCost(row.sub_precost || '');
        setSubUpcharge(row.sub_upcharge || '');
        setSubShippingTo(row.sub_shipping_to || '');
        setSubShippingFrom(row.sub_shipping_from || '');
        setSubNotes(row.sub_notes || '');

        setSubPSAorderArrived(
          row.PSA_Order_Arrived ? convertISOToDateInputValue(row.PSA_Order_Arrived) : ''
        );
        setSubPSAorderPrep(
          row.PSA_Order_Prep ? convertISOToDateInputValue(row.PSA_Order_Prep) : ''
        );
        setSubPSAresearchID(
          row.PSA_Research_ID ? convertISOToDateInputValue(row.PSA_Research_ID) : ''
        );
        setSubPSAgrading(
          row.PSA_Grading ? convertISOToDateInputValue(row.PSA_Grading) : ''
        );
        setSubPSAassembly(
          row.PSA_Assembly ? convertISOToDateInputValue(row.PSA_Assembly) : ''
        );
        setSubPSAgradesReady(
          row.PSA_Grades_Ready ? convertISOToDateInputValue(row.PSA_Grades_Ready) : ''
        );
        setSubPSAqaChecks(
          row.PSA_QA_Checks ? convertISOToDateInputValue(row.PSA_QA_Checks) : ''
        );
        setSubPSAcompleted(
          row.PSA_Completed ? convertISOToDateInputValue(row.PSA_Completed) : ''
        );
      })
      .catch((error) => {
        console.error('Error fetching submission data:', error);
      });
  }, [id]);

  const handleSave = async () => {
    if (!subID) return;

    const updatedSubData = {
      sub_grader: subGrader,
      sub_order_number: subOrderNumber,
      sub_date: subDate || null,
      sub_return_date: subReturnDate || null,
      sub_precost: subPreCost,
      sub_upcharge: subUpcharge,
      sub_total_cards: subTotalCards,
      sub_shipping_to: subShippingTo,
      sub_shipping_from: subShippingFrom,
      sub_notes: subNotes,
      PSA_Order_Arrived: subPSAorderArrived || null,
      PSA_Order_Prep: subPSAorderPrep || null,
      PSA_Research_ID: subPSAresearchID || null,
      PSA_Grading: subPSAgrading || null,
      PSA_Assembly: subPSAassembly || null,
      PSA_Grades_Ready: subPSAgradesReady || null,
      PSA_QA_Checks: subPSAqaChecks || null,
      PSA_Completed: subPSAcompleted || null,
    };

    try {
      const res = await axios.post(
        `https://api.alientrader.cards/submission/edit/${subID.sub_id}`,
        updatedSubData
      );
      console.log('Submission information updated successfully:', res.data);
      alert('Submission saved successfully!');
      navigate(-1);
    } catch (error) {
      console.error('Error updating Submission information:', error);
    }
  };

  return (
    <div>
      {/* Top actions bar */}
      <div className="actions">
        <div className="subBack">
          <CancelIcon fontSize="large" onClick={goBack} />
        </div>
        <div className="sub">
          <h1>Submission</h1>
        </div>
        <div className="subEdit">
          <button className="edit-button" onClick={handleSave}>
            <SaveIcon fontSize="large" />
          </button>
        </div>
      </div>

      <Container>
        {/* Submission Info box */}
        <Row className="d-flex align-items-center justify-content-center">
          <Col sm={8} className="subAddBox shadow-sm">
            <Row>
              <div className="subAddHeader">Submission Info</div>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Grader:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="text"
                    id="sub_grader"
                    className="edit-input"
                    value={subGrader}
                    onChange={(e) => setSubGrader(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Order Number:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="text"
                    id="sub_order_number"
                    className="edit-input"
                    value={subOrderNumber}
                    onChange={(e) => setSubOrderNumber(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Submission Date:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="date"
                    id="sub_date"
                    className="edit-input"
                    value={subDate}
                    onChange={(e) => setSubDate(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Return Date:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="date"
                    id="sub_return_date"
                    className="edit-input"
                    value={subReturnDate}
                    onChange={(e) => setSubReturnDate(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Total Cards:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="text"
                    id="sub_total_cards"
                    className="edit-input"
                    value={subTotalCards}
                    onChange={(e) => setSubTotalCards(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Pre-Cost:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="text"
                    id="sub_precost"
                    className="edit-input"
                    value={subPreCost}
                    onChange={(e) => setSubPreCost(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Upcharge:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="text"
                    id="sub_upcharge"
                    className="edit-input"
                    value={subUpcharge}
                    onChange={(e) => setSubUpcharge(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Shipping To:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="text"
                    id="sub_shipping_to"
                    className="edit-input"
                    value={subShippingTo}
                    onChange={(e) => setSubShippingTo(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Shipping From:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="text"
                    id="sub_shipping_from"
                    className="edit-input"
                    value={subShippingFrom}
                    onChange={(e) => setSubShippingFrom(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Notes:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <textarea
                    id="sub_notes"
                    className="edit-input"
                    value={subNotes}
                    onChange={(e) => setSubNotes(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <br />
            </Row>
          </Col>
        </Row>

        {/* PSA Info box */}
        <Row className="d-flex align-items-center justify-content-center">
          <Col lg={4} md={5} sm={8} className="subAddBox shadow-sm">
            <Row>
              <div className="subAddHeader">PSA Info</div>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Order Arrived:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="date"
                    id="PSA_Order_Arrived"
                    className="edit-input"
                    value={subPSAorderArrived}
                    onChange={(e) => setSubPSAorderArrived(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Order Prep:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="date"
                    id="PSA_Order_Prep"
                    className="edit-input"
                    value={subPSAorderPrep}
                    onChange={(e) => setSubPSAorderPrep(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Research / ID:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="date"
                    id="PSA_Research_ID"
                    className="edit-input"
                    value={subPSAresearchID}
                    onChange={(e) => setSubPSAresearchID(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Grading:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="date"
                    id="PSA_Grading"
                    className="edit-input"
                    value={subPSAgrading}
                    onChange={(e) => setSubPSAgrading(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Assembly:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="date"
                    id="PSA_Assembly"
                    className="edit-input"
                    value={subPSAassembly}
                    onChange={(e) => setSubPSAassembly(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Grades Ready:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="date"
                    id="PSA_Grades_Ready"
                    className="edit-input"
                    value={subPSAgradesReady}
                    onChange={(e) => setSubPSAgradesReady(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                QA Checks:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="date"
                    id="PSA_QA_Checks"
                    className="edit-input"
                    value={subPSAqaChecks}
                    onChange={(e) => setSubPSAqaChecks(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="d-flex align-items-center justify-content-center">
              <Col xs={4} className="custom-info-title">
                Completed:
              </Col>
              <Col>
                <div className="custom-input-val">
                  <input
                    type="date"
                    id="PSA_Completed"
                    className="edit-input"
                    value={subPSAcompleted}
                    onChange={(e) => setSubPSAcompleted(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <br />
            </Row>
          </Col>
        </Row>
      </Container>

      {/* Bottom actions bar (optional; you can remove if you only want top) */}
      <div className="actions">
        <div className="subBack">
          <CancelIcon fontSize="large" onClick={goBack} />
        </div>
        <div className="sub">
          <h1>-</h1>
        </div>
        <div className="subEdit">
          <button className="edit-button" onClick={handleSave}>
            <SaveIcon fontSize="large" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubAdd;
